<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="61"
    viewBox="0 0 64 61"
    fill="none"
  >
    <g filter="url(#filter0_f_3818_27515)">
      <ellipse
        cx="32.0408"
        cy="32.253"
        rx="11.1658"
        ry="15"
        transform="rotate(45 32.0408 32.253)"
        fill="#A370F7"
      />
    </g>
    <path
      d="M14.74 37.8499L14.72 29.4499L10.6 36.3699H9.14L5.04 29.6299V37.8499H2V23.8499H4.68L9.92 32.5499L15.08 23.8499H17.74L17.78 37.8499H14.74Z"
      fill="currentColor"
    />
    <path
      d="M25.2216 26.9299C26.8882 26.9299 28.1682 27.3299 29.0616 28.1299C29.9549 28.9165 30.4016 30.1099 30.4016 31.7099V37.8499H27.4816V36.5099C26.8949 37.5099 25.8016 38.0099 24.2016 38.0099C23.3749 38.0099 22.6549 37.8699 22.0416 37.5899C21.4416 37.3099 20.9816 36.9232 20.6616 36.4299C20.3416 35.9365 20.1816 35.3765 20.1816 34.7499C20.1816 33.7499 20.5549 32.9632 21.3016 32.3899C22.0616 31.8165 23.2282 31.5299 24.8016 31.5299H27.2816C27.2816 30.8499 27.0749 30.3299 26.6616 29.9699C26.2482 29.5965 25.6282 29.4099 24.8016 29.4099C24.2282 29.4099 23.6616 29.5032 23.1016 29.6899C22.5549 29.8632 22.0882 30.1032 21.7016 30.4099L20.5816 28.2299C21.1682 27.8165 21.8682 27.4965 22.6816 27.2699C23.5082 27.0432 24.3549 26.9299 25.2216 26.9299ZM24.9816 35.9099C25.5149 35.9099 25.9882 35.7899 26.4016 35.5499C26.8149 35.2965 27.1082 34.9299 27.2816 34.4499V33.3499H25.1416C23.8616 33.3499 23.2216 33.7699 23.2216 34.6099C23.2216 35.0099 23.3749 35.3299 23.6816 35.5699C24.0016 35.7965 24.4349 35.9099 24.9816 35.9099Z"
      fill="currentColor"
    />
    <path
      d="M44.4425 27.0899V36.0499C44.4425 38.0232 43.9292 39.4899 42.9025 40.4499C41.8758 41.4099 40.3758 41.8899 38.4025 41.8899C37.3625 41.8899 36.3758 41.7632 35.4425 41.5099C34.5092 41.2565 33.7358 40.8899 33.1225 40.4099L34.3625 38.1699C34.8158 38.5432 35.3892 38.8365 36.0825 39.0499C36.7758 39.2765 37.4692 39.3899 38.1625 39.3899C39.2425 39.3899 40.0358 39.1432 40.5425 38.6499C41.0625 38.1699 41.3225 37.4365 41.3225 36.4499V35.9899C40.5092 36.8832 39.3758 37.3299 37.9225 37.3299C36.9358 37.3299 36.0292 37.1165 35.2025 36.6899C34.3892 36.2499 33.7425 35.6365 33.2625 34.8499C32.7825 34.0632 32.5425 33.1565 32.5425 32.1299C32.5425 31.1032 32.7825 30.1965 33.2625 29.4099C33.7425 28.6232 34.3892 28.0165 35.2025 27.5899C36.0292 27.1499 36.9358 26.9299 37.9225 26.9299C39.4825 26.9299 40.6692 27.4432 41.4825 28.4699V27.0899H44.4425ZM38.5425 34.7699C39.3692 34.7699 40.0425 34.5299 40.5625 34.0499C41.0958 33.5565 41.3625 32.9165 41.3625 32.1299C41.3625 31.3432 41.0958 30.7099 40.5625 30.2299C40.0425 29.7365 39.3692 29.4899 38.5425 29.4899C37.7158 29.4899 37.0358 29.7365 36.5025 30.2299C35.9692 30.7099 35.7025 31.3432 35.7025 32.1299C35.7025 32.9165 35.9692 33.5565 36.5025 34.0499C37.0358 34.5299 37.7158 34.7699 38.5425 34.7699Z"
      fill="currentColor"
    />
    <path
      d="M58.0264 27.0899L53.4864 37.8499H50.2664L45.7464 27.0899H48.9664L51.9464 34.4099L55.0264 27.0899H58.0264Z"
      fill="currentColor"
    />
    <path
      d="M59.2995 27.0899H62.4195V37.8499H59.2995V27.0899ZM60.8595 25.5899C60.2862 25.5899 59.8195 25.4232 59.4595 25.0899C59.0995 24.7565 58.9195 24.3432 58.9195 23.8499C58.9195 23.3565 59.0995 22.9432 59.4595 22.6099C59.8195 22.2765 60.2862 22.1099 60.8595 22.1099C61.4329 22.1099 61.8995 22.2699 62.2595 22.5899C62.6195 22.9099 62.7995 23.3099 62.7995 23.7899C62.7995 24.3099 62.6195 24.7432 62.2595 25.0899C61.8995 25.4232 61.4329 25.5899 60.8595 25.5899Z"
      fill="currentColor"
    />
    <defs>
      <filter
        id="filter0_f_3818_27515"
        x="0.532055"
        y="0.745434"
        width="63.016"
        height="63.0155"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="9.14218"
          result="effect1_foregroundBlur_3818_27515"
        />
      </filter>
    </defs>
  </svg>
</template>
